import { panelUpgrade } from './panelUpgrade';
import { simpleTextFieldUpgrade } from './simpleTextFieldUpgrade';
import { textContentUpgrade } from './textContentUpgrade';
/**
 * Given a CimDoc with a potentially older contract, upgrade it to the new contract.
 */
export function upgradeCimDoc(cimDoc) {
    panelUpgrade(cimDoc);
    textContentUpgrade(cimDoc);
    simpleTextFieldUpgrade(cimDoc);
    return cimDoc;
}
//# sourceMappingURL=upgradeCimDoc.js.map